import { theme } from "styles/mui-config";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { Link } from "react-router-dom";

export const StyledTypographyContent = styled.pre`
  line-height: 35px !important;
  padding: 10px;
  font-family: inherit;
  color: #414141;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
`;
export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledImage = styled.img`
  border-radius: 15px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  width: 100% !important;
`;

export const StyledLink = styled(Link)`
  color: rgb(0, 32, 46);
  margin-right: 20px;
`;
